import type { BoggleResolvedChallengeBonus } from '~/boggle/config/challenges/modTypes'
import { formatResolvedBonusDisplayFromDefinition } from '~/boggle/config/bonuses/formatResolvedBonusDisplay'
import type { BoggleChallengeBonusResolverContext } from '~/boggle/lib/challenge/resolveModFamily'
import type { BoggleChallengeBonusDefinition } from '../bonusDefinition'
import type { BoggleBonusValue } from '../types'

export const palindromeBonusDefinition: BoggleChallengeBonusDefinition = {
  description: 'Word reads the same forwards and backwards',
  id: 'palindrome',
  name: 'Palindrome',
  parameterDefinitions: {},
  selectionWeight: 1,
  shortLabel: 'Palindrome',
}

export function resolvePalindromeBonus(
  family: BoggleChallengeBonusDefinition,
  rngState: number,
  _context: BoggleChallengeBonusResolverContext,
  value: BoggleBonusValue,
): {
  mod: BoggleResolvedChallengeBonus
  rngState: number
} {
  const display = formatResolvedBonusDisplayFromDefinition(family, {})

  return {
    mod: {
      description: display.description,
      effects: [],
      familyId: family.id,
      id: family.id,
      name: display.name,
      outcomes: [],
      parameters: {},
      shortLabel: display.shortLabel,
      value,
    },
    rngState,
  }
}
